import {
  mindsdb,
  newsfresh_App,
  proj_QR_code,
  doions,
  EIRA
  } from "../assets";
  
  export const navLinks = [
    {
      id: "about",
      title: "About",
    },
    {
      id: "work",
      title: "Work",
    },
    {
      id: "contact",
      title: "Contact",
    },
  ];
  
  const experiences = [
    {
      title: "Open Source Contributor",
      company_name: "MindsDB",
      icon: mindsdb,
      iconBg: "#383E56",
      date: "June 2023 - Present",
      points: [
        "Discovered and promptly reported a critical security vulnerability.",
        "Mitigating potential data breaches and safeguarding the sensitive information of thousands of users while ensuring uninterrupted service delivery for the product team as per industry trends."
      ],
    },
  
    {
      title: "Project Intern",
      company_name: "Doions Pvt. Ltd",
      icon: doions,
      iconBg: "#383E56",
      date: "Feb 2023 - March 2023",
      points: [
        "Designed and implemented 15+ web components for a leading SaaS site with React.Js framework, resulting in a 45% increase in mobile conversion rate.",
        "Engineered and optimized web components design using React,resulting in a 40% increase in page load speed and a 25% decrease in bounce rate."
      ],
    }
  ];
  
  
  const projects = [
    {
      name: "News Fresh App",
      description:
        "Developed an modern native android application that uses News API to fetch the random latest news of all around the global with relevant images with its title",
      tags: [
        {
          name: "Kotlin",
          color: "blue-text-gradient",
        },
        {
          name: "News_API",
          color: "pink-text-gradient",
        },
        {
          name: "Android Studio",
          color: "green-text-gradient",
        }
      ],
      image: newsfresh_App,
      source_code_link: "https://github.com/truesoni/newsfresh",
    },
    {
      name: "EIRA- An AI GuideBot",
      description:
        "Collaborated with a team to build an AI-powered chatbot that autonomously handled 75% of customer inquiries,resulting in a 40% reduction in support response time and a 20% increase in customer satisfaction",
      tags: [
        {
          name: "Python",
          color: "blue-text-gradient",
        },
        {
          name: "Text-to-Speech API",
          color: "green-text-gradient",
        },
        {
          name: "ChatBot",
          color: "pink-text-gradient",
        },
      ],
      image: EIRA,
      source_code_link: "https://github.com/tcchawla/Echo---MERN",
    },
    // {
    //   name: "QR and Barcode Scanner App",
    //   description:
    //     "Developed and launched an advanced QR code and barcode scanner with the capability to read and interpret various formats, including text, URL, product, contact, calendar, email, Wi-Fi, and more.",
    //   tags: [
    //     {
    //       name: "Java",
    //       color: "blue-text-gradient",
    //     },
    //     {
    //       name: "Android Studio",
    //       color: "green-text-gradient",
    //     },
    //     {
    //       name: "ZXing_API",
    //       color: "pink-text-gradient",
    //     },
    //   ],
    //   image: proj_QR_code,
    //   source_code_link: "https://play.google.com/store/apps/details?id=com.dev.qrcodescannerApp",
    // }
  ];
  
  export {experiences, projects };